import z from "zod";
import { AuditMetaSchema } from "./auditMetaTypes";
import { GrantsSchema } from "./grantsTypes";
import { AssetIdSchema, LabelIdSchema } from "./idTypes";
import { TenancySchema } from "./tenancyTypes";

const AssetLifecycleStateSchema = z.enum([
  "AWAITING_UPLOAD",
  "UPLOADED",
  "QUEUED_FOR_PROCESSING",
  "PROCESSING",
  "INDEXING",
  "READY",
  "FAILED",
  "REPROCESSING",
  "ARCHIVED",
  "QUARANTINED",
  "DELETE_REQUESTED",
  "DELETED",
  "TOO_MANY_REQUESTS",
]);

export type AssetLifecycleState = z.infer<typeof AssetLifecycleStateSchema>;

const AssetBlobSchema = z.object({
  bucket: z.string(),
  key: z.string(),
});

const AssetStatusSchema = z.object({
  state: AssetLifecycleStateSchema,
  modifiedAt: z.string(), // ISO 8601 timestamp
});

export const AssetSchema = z
  .object({
    id: AssetIdSchema,
    name: z.string(),
    description: z.string(),
    filename: z.string(),
    fileSizeInBytes: z.number(),
    mimeType: z.string(),
    md5: z.string(),
    blob: AssetBlobSchema,
    status: AssetStatusSchema,
    isArchived: z.boolean(),
    labels: z.array(LabelIdSchema).optional(),
    grants: GrantsSchema,
    source: z.string().optional(),
    sourceRef: z.string().optional(),
  })
  .extend(TenancySchema.shape)
  .extend(AuditMetaSchema.shape);

export type Asset = z.infer<typeof AssetSchema>;

export const AssetSignedUrlSchema = z.object({
  url: z.string(),
  expiresAt: z.string(),
});
